"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatsDelta$ = exports.StatsDelta$outboundSchema = exports.StatsDelta$inboundSchema = exports.ValueRounded$ = exports.ValueRounded$outboundSchema = exports.ValueRounded$inboundSchema = exports.Value$ = exports.Value$outboundSchema = exports.Value$inboundSchema = void 0;
exports.valueToJSON = valueToJSON;
exports.valueFromJSON = valueFromJSON;
exports.valueRoundedToJSON = valueRoundedToJSON;
exports.valueRoundedFromJSON = valueRoundedFromJSON;
exports.statsDeltaToJSON = statsDeltaToJSON;
exports.statsDeltaFromJSON = statsDeltaFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.Value$inboundSchema = z
    .union([z.number().int(), z.number()]);
/** @internal */
exports.Value$outboundSchema = z.union([z.number().int(), z.number()]);
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var Value$;
(function (Value$) {
    /** @deprecated use `Value$inboundSchema` instead. */
    Value$.inboundSchema = exports.Value$inboundSchema;
    /** @deprecated use `Value$outboundSchema` instead. */
    Value$.outboundSchema = exports.Value$outboundSchema;
})(Value$ || (exports.Value$ = Value$ = {}));
function valueToJSON(value) {
    return JSON.stringify(exports.Value$outboundSchema.parse(value));
}
function valueFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.Value$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'Value' from JSON`);
}
/** @internal */
exports.ValueRounded$inboundSchema = z.union([z.number().int(), z.number()]);
/** @internal */
exports.ValueRounded$outboundSchema = z.union([z.number().int(), z.number()]);
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var ValueRounded$;
(function (ValueRounded$) {
    /** @deprecated use `ValueRounded$inboundSchema` instead. */
    ValueRounded$.inboundSchema = exports.ValueRounded$inboundSchema;
    /** @deprecated use `ValueRounded$outboundSchema` instead. */
    ValueRounded$.outboundSchema = exports.ValueRounded$outboundSchema;
})(ValueRounded$ || (exports.ValueRounded$ = ValueRounded$ = {}));
function valueRoundedToJSON(valueRounded) {
    return JSON.stringify(exports.ValueRounded$outboundSchema.parse(valueRounded));
}
function valueRoundedFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.ValueRounded$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'ValueRounded' from JSON`);
}
/** @internal */
exports.StatsDelta$inboundSchema = z.object({
    value: z.union([z.number().int(), z.number()]),
    value_rounded: z.union([z.number().int(), z.number()]),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "value_rounded": "valueRounded",
    });
});
/** @internal */
exports.StatsDelta$outboundSchema = z.object({
    value: z.union([z.number().int(), z.number()]),
    valueRounded: z.union([z.number().int(), z.number()]),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        valueRounded: "value_rounded",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var StatsDelta$;
(function (StatsDelta$) {
    /** @deprecated use `StatsDelta$inboundSchema` instead. */
    StatsDelta$.inboundSchema = exports.StatsDelta$inboundSchema;
    /** @deprecated use `StatsDelta$outboundSchema` instead. */
    StatsDelta$.outboundSchema = exports.StatsDelta$outboundSchema;
})(StatsDelta$ || (exports.StatsDelta$ = StatsDelta$ = {}));
function statsDeltaToJSON(statsDelta) {
    return JSON.stringify(exports.StatsDelta$outboundSchema.parse(statsDelta));
}
function statsDeltaFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.StatsDelta$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'StatsDelta' from JSON`);
}
//# sourceMappingURL=statsdelta.js.map